<template>
	<p-panel-properties class="panel-properties">
		<p-property-tile title="Interactive block">
			<v-switch
				:input-value="isInteractive"
				:readonly="!canChangeInteractivity"
				@change="updateBlockInteractivity"
			></v-switch>
		</p-property-tile>

		<v-subheader class="interactivity-disclaimer">
			When this option is enabled, the block will behave as an interactive block. This means that when you interact with
			it, the Flip Card will not flip.
		</v-subheader>

		<v-subheader class="interactivity-disclaimer" style="margin-top: 8px">
			IMPORTANT: If the block has an associated action, it will behave as an interactive block.
		</v-subheader>

		<v-subheader v-if="blockHasAction" class="action-warning" style="margin-top: 8px; color: red">
			* This block has an action.
		</v-subheader>

		<p></p>
	</p-panel-properties>
</template>

<script>
import PPropertyTile from '../utils/PPropertyTile.vue';
import PPanelProperties from '../utils/PPanelProperties.vue';
export default {
	props: ['selectedBlock', 'selectedBlockParent'],
	components: {
		PPropertyTile,
		PPanelProperties
	},
	data() {
		return {
			isInteractive: false,
			canChangeInteractivity: true,
			blockHasAction: false
		};
	},
	computed: {
		selectedBlockId() {
			return this.selectedBlock.id;
		}
	},
	mounted() {
		this.blockHasAction = this.checkBlockHasActions(this.selectedBlock);
		this.canChangeInteractivity = !this.blockHasAction;
		this.isInteractive = this.checkBlockIsInteractive(this.selectedBlock);

		if (!this.isInteractive && this.blockHasAction) {
			this.addBlockToInteractiveBlocksList(this.selectedBlockId);
			this.isInteractive = true;
		}
	},
	methods: {
		updateBlockInteractivity(isInteractive) {
			this.isInteractive = isInteractive;

			if (isInteractive) {
				this.addBlockToInteractiveBlocksList(this.selectedBlockId);
				return;
			}

			this.removeBlockFromInteractiveBlocksList(this.selectedBlockId);
		},
		addBlockToInteractiveBlocksList(blockId) {
			const interactiveBlockIds = this.selectedBlockParent.data.interactiveBlockIds;

			if (!interactiveBlockIds.includes(blockId)) {
				interactiveBlockIds.push(blockId);
			}
		},
		removeBlockFromInteractiveBlocksList(blockId) {
			const interactiveBlockIds = this.selectedBlockParent.data.interactiveBlockIds;

			this.selectedBlockParent.data.interactiveBlockIds = interactiveBlockIds.filter(id => id !== blockId);
		},
		checkBlockIsInteractive(block) {
			const interactiveBlockIds = this.selectedBlockParent.data.interactiveBlockIds;
			return interactiveBlockIds.includes(block.id);
		},
		checkBlockHasActions(block) {
			return block.actions && block.actions.length > 0;
		}
	},
	watch: {
		selectedBlockId() {
				this.blockHasAction = this.checkBlockHasActions(this.selectedBlock);
				this.canChangeInteractivity = !this.blockHasAction;
				this.isInteractive = this.checkBlockIsInteractive(this.selectedBlock);
		}
	}
};
</script>

<style>
.panel-properties .v-list__tile__action {
	overflow: inherit !important;
}

.interactivity-disclaimer,
.action-warning {
	height: unset !important;
}
</style>
